import React from "react";

import UserManagement from "../../../../components/v2/Admin/UserManagement";
import AdminAttendantsService from "../../../../services/AdminAttendantsService";

export default function AdminAttendants() {
  return <UserManagement service={AdminAttendantsService} resource="attendants" />;
}
